import { useEffect, useState } from 'react';

const useDebounce = <R>(value: R, delay: number): R => {
  const [debouncedValue, setDebouncedValue] = useState<R>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

export default useDebounce;
